// app/[locale]/(routes)/crm/opportunities/table-data/schema.tsx
import { z } from "zod";

// We're keeping a simple non-relational schema here.
// IRL, you will have a schema for your data models.
export const opportunitySchema = z.object({
  //TODO: fix all the types and nullable
  id: z.string(),
  name: z.string(),
  description: z.string(),
  next_step: z.string().nullable(),
  comments: z.string().nullable(), // Added comments field

  status: z.string().nullable(),
  budget: z.number().nullable(),
  expected_revenue: z.number().nullable(),
  assigned_account: z.object({}).optional().nullable(),
  assigned_sales_stage: z.object({}).optional().nullable(),
  assigned_to_user: z.object({}).optional().nullable(),
  assigned_leadsIDs: z.string().nullable(),
  
  // Add the assigned_leads to the schema
  assigned_leads: z.object({
    id: z.string(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    city: z.string().nullable(),
    advisorName: z.string().nullable(),
    advisorEmail: z.string().nullable(),
    state: z.string().nullable(),
    assetInterests: z.array(z.string()).optional(),
    assigned_to_user: z.object({
      name: z.string().nullable()
    }).nullable()
  }).nullable(),
});

export type Opportunity = z.infer<typeof opportunitySchema>;
